import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "model-manager" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "table-bar" }
const _hoisted_4 = { class: "table-tools" }

import { ref, reactive, computed } from 'vue';
import { modelDataList, toCamelCase } from '@/data/modelData';
import { FormInstance, message } from 'ant-design-vue';

interface ModelItem {
  key: string;
  type: string;
  name: string;
  identifier: string;
  dataType: string;
  accessType: string;
  definition: string;
  pluginFile?: any; // 新增字段，? 表示可选，具体类型根据上传组件的返回值确定
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ModelManager',
  setup(__props) {

const columns = [
  { title: '功能类型', dataIndex: 'type', key: 'type' },
  { title: '功能名称', dataIndex: 'name', key: 'name' },
  { title: '标识符', dataIndex: 'identifier', key: 'identifier' },
  { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
  { title: '读写类型', dataIndex: 'accessType', key: 'accessType' },
  { title: '数据定义', dataIndex: 'definition', key: 'definition' },
  // 可以考虑添加一列显示插件信息，暂时不加
  { title: '操作', key: 'action' }
];

const modelData = ref<ModelItem[]>(JSON.parse(JSON.stringify(modelDataList))); // Deep copy

const isModalVisible = ref(false);
const isEditing = ref(false);
const currentModel = reactive<Partial<ModelItem>>({});
let editingKey = '';

const searchParams = reactive({
  type: '',
  identifier: ''
});

const filteredData = computed(() => {
  return modelData.value.filter(item => {
    const typeMatch = item.type.toLowerCase().includes(searchParams.type.toLowerCase());
    const identifierMatch = item.identifier.toLowerCase().includes(searchParams.identifier.toLowerCase());
    return typeMatch && identifierMatch;
  });
});

const handleSearch = () => {
  // Computed property handles filtering, this function can be used for any additional logic if needed
  console.log('Searching with:', searchParams);
};

const resetSearch = () => {
  searchParams.type = '';
  searchParams.identifier = '';
};

const showAddModel = () => {
  isEditing.value = false;
  Object.assign(currentModel, {
    type: '',
    name: '',
    identifier: '',
    dataType: '结构化数据',
    accessType: '读写',
    definition: '',
    pluginFile: [] // 初始化为空数组，用于 a-upload
  });
  isModalVisible.value = true;
};

const showEditModel = (record: ModelItem) => {
  isEditing.value = true;
  editingKey = record.key;
  Object.assign(currentModel, { ...record });
  isModalVisible.value = true;
};

const handleOk = async () => {
  if (!currentModel.name || !currentModel.type) {
    message.error('功能类型和功能名称不能为空！');
    return;
  }
  if (!currentModel.identifier) {
    currentModel.identifier = toCamelCase(currentModel.name || '');
  }

  if (isEditing.value) {
    const index = modelData.value.findIndex(item => item.key === editingKey);
    if (index > -1) {
      modelData.value[index] = { ...currentModel, key: editingKey } as ModelItem;
      message.success('编辑成功');
    }
  } else {
    const newKey = `model-${Date.now()}`;
    modelData.value.push({ ...currentModel, key: newKey } as ModelItem);
    message.success('新增成功');
  }
  isModalVisible.value = false;
};

const deleteModel = (key: string) => {
  modelData.value = modelData.value.filter(item => item.key !== key);
  message.success('删除成功');
};


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_form, { layout: "inline" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "功能类型" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: searchParams.type,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.type) = $event)),
                    style: {"width":"180px"},
                    placeholder: "请输入功能类型"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "标识符" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: searchParams.identifier,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.identifier) = $event)),
                    style: {"width":"180px"},
                    placeholder: "请输入标识符"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: handleSearch
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("查询")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { onClick: resetSearch }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("重置")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: showAddModel
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("新增")
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, { type: "text" }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-rotate-right" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, { type: "text" }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-table-cells-large" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, { type: "text" }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-gear" })
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_a_table, {
          columns: columns,
          "data-source": filteredData.value,
          pagination: false,
          style: {"margin-top":"16px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    size: "small",
                    onClick: ($event: any) => (showEditModel(record))
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("编辑")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_divider, { type: "vertical" }),
                  _createVNode(_component_a_popconfirm, {
                    title: "确定删除吗?",
                    "ok-text": "确定",
                    "cancel-text": "取消",
                    onConfirm: ($event: any) => (deleteModel(record.key))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        size: "small",
                        danger: ""
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("删除")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          emptyText: _withCtx(() => [
            _createVNode(_component_a_empty, { description: "暂无数据" })
          ]),
          _: 1
        }, 8, ["data-source"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      open: isModalVisible.value,
      "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((isModalVisible).value = $event)),
      title: isEditing.value ? '编辑模型' : '新增模型',
      "ok-text": "确定",
      "cancel-text": "取消",
      onOk: handleOk
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: currentModel,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "功能类型",
              name: "type",
              rules: [{ required: true, message: '请输入功能类型!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentModel.type,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((currentModel.type) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "功能名称",
              name: "name",
              rules: [{ required: true, message: '请输入功能名称!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentModel.name,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((currentModel.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "标识符",
              name: "identifier"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentModel.identifier,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((currentModel.identifier) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "数据类型",
              name: "dataType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentModel.dataType,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((currentModel.dataType) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "读写类型",
              name: "accessType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentModel.accessType,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((currentModel.accessType) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "数据定义",
              name: "definition"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: currentModel.definition,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((currentModel.definition) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "上传插件",
              name: "pluginFile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  "file-list": currentModel.pluginFile,
                  "onUpdate:fileList": _cache[8] || (_cache[8] = ($event: any) => ((currentModel.pluginFile) = $event)),
                  name: "file",
                  action: "/upload/dummy",
                  "before-upload": () => false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-upload" }),
                        _cache[15] || (_cache[15] = _createTextVNode(" 点击上传 "))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open", "title"])
  ]))
}
}

})